import { useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import styles from "./WideModal.module.scss";

const WideModal = ({ 
  isOpen, 
  onClose, 
  children, 
  className,
  showCloseButton = true 
}) => {
  const modalRef = useRef();

  // Handle ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  // Handle backdrop click
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const modalContent = (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div 
        className={classNames(styles.modal, className)} 
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        {showCloseButton && (
          <button 
            className={styles.closeButton}
            onClick={onClose}
            type="button"
            aria-label="Close modal"
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default WideModal;